import script from "./0_ContractWriter.vue?vue&type=script&setup=true&lang=ts&name=ContractCURD"
export * from "./0_ContractWriter.vue?vue&type=script&setup=true&lang=ts&name=ContractCURD"

const __exports__ = script;

export default __exports__